import jwt_decode from 'jwt-decode'

const CHECK_INTERVAL_MS = 15000

function isRefreshTokenExpired (rawToken) {
  try {
    const refresh = JSON.parse(rawToken).refresh
    if (!refresh) return true
    return jwt_decode(refresh).exp <= Date.now() / 1000
  } catch (e) {
    return true
  }
}

// Redirects to /login as soon as the session ends (manual logout, expired
// refresh token, token removed from another tab), without waiting for an API call.
export function startSessionWatcher (store, router) {
  const goToLogin = () => {
    if (router.currentRoute.path !== '/login') {
      router.push('/login').catch(() => {})
    }
  }

  const check = () => {
    const token = store.state.auth.token
    if (token && isRefreshTokenExpired(token)) {
      store.commit('AUTH_LOGOUT')
    }
  }

  store.watch(
    (state) => !!state.auth.token,
    (isAuthenticated) => {
      if (!isAuthenticated) goToLogin()
    }
  )

  setInterval(check, CHECK_INTERVAL_MS)
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) check()
  })
  window.addEventListener('focus', check)
}
